import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-4" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-center mt-4 mb-4" }, " Contact Form Topics ")
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-success"
}
const _hoisted_6 = {
  key: 1,
  class: "small striped mb-4",
  id: "contact_table"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Topic "),
    /*#__PURE__*/_createElementVNode("th", null, " Role "),
    /*#__PURE__*/_createElementVNode("th", null, " Email "),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mt-4 mb-4" }, " Create New Contact Topic", -1)
const _hoisted_12 = { class: "form-group row mb-4 d-flex flex-column align-items-center gap-4" }
const _hoisted_13 = { class: "d-flex justify-content-between gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "topic",
  class: "col-form-label w-25 w-sm-auto text-md-right"
}, " Topic: ", -1)
const _hoisted_15 = { class: "d-flex justify-content-between gap-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "role",
  class: "col-form-label w-25 w-sm-auto text-md-right"
}, " Role: ", -1)
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "d-flex justify-content-between gap-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "email",
  class: "col-form-label w-25 w-sm-auto text-md-right"
}, " Email: ", -1)
const _hoisted_20 = { class: "d-flex justify-content-end" }
const _hoisted_21 = {
  type: "submit",
  class: "btn btn-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          ($setup.success)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.success), 1))
            : _createCommentVNode("", true),
          ($setup.topics.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.topics, (topic) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: topic.UIContactTopicID
                    }, [
                      _createElementVNode("td", null, _toDisplayString(topic.Topic), 1),
                      _createElementVNode("td", null, _toDisplayString(topic.RoleID), 1),
                      _createElementVNode("td", null, _toDisplayString(topic.Email), 1),
                      _createElementVNode("td", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "btn btn-danger btn-sm",
                          onClick: ($event: any) => ($setup.handleDelete(topic.UIContactTopicID))
                        }, "Delete", 8, _hoisted_9)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.errors.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            class: "container border p-4",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleAddContact && $setup.handleAddContact(...args)), ["prevent"]))
          }, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "topic",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.newTopic.Topic) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, $setup.newTopic.Topic]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("select", {
                  id: "role",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.newTopic.Role) = $event))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roles, (role) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: role.RoleID,
                      value: role.RoleID
                    }, _toDisplayString(role.RoleName), 9, _hoisted_17))
                  }), 128))
                ], 512), [
                  [_vModelSelect, $setup.newTopic.Role]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "email",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.newTopic.Email) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, $setup.newTopic.Email]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", _hoisted_21, _toDisplayString($setup.loadingSubmit ? 'Submitting...' : 'Create'), 1)
              ])
            ])
          ], 32)
        ]))
  ]))
}